export type { LemonTagProps, LemonTagType } from './LemonTag'
export { LemonTag } from './LemonTag'
